export default "__VITE_ASSET__Bc$Tl2ju__"